import { useAppSelector } from "../../../../Hooks/redux/useAppSelector";
import { BalanceBlock, BalanceSpan } from "./styled";

const HeaderBalanceBlock = () => {
  const dataUser = useAppSelector((state) => state.clientDataSlice.user);

  return (
    <BalanceBlock>
      <BalanceSpan>
        {dataUser?.currency} {dataUser?.balance?.toFixed(2)}
      </BalanceSpan>
    </BalanceBlock>
  );
};

export default HeaderBalanceBlock;
